exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-buy-tabs[data-v-2235f9c5] {\n  padding: 12px;\n}\n", ""]);

// exports
